const specialists = [
  {
    id: 1,
    name: "Floripa Delivery",
    services: "Домашний творог, торты, десерты",
    description: "Мы — семья из России, которая проживает в Бразилии уже больше года. Мы, как никто, понимаем, что в эмиграции скучаешь по родным вкусам, поэтому решили организовать доставку десертов, приготовленных нами с любовью по проверенным семейным рецептам, некоторые из которых перешли к нам от наших родителей и даже бабушек. Каждое блюдо мы готовим, как для себя любимых, поэтому мы не экономим на продуктах и выбираем только самое лучшее и свежее!",
    price: [
      { name: "Творог (1 кг)", price: "70 BRL" },
      { name: "Сырники (1 кг)", price: "100 BRL" },
      { name: "Торт Медовик (1,6 кг)", price: "190 BRL" },
      { name: "Торт Наполеон (1,8 кг)", price: "190 BRL" },
      { name: "Королевская ватрушка (1,4 кг)", price: "150 BRL" },
      { name: "Птичье молоко (500 г)", price: "70 BRL" },
      { name: "Яблочная пастила (500 г)", price: "65 BRL" },
    ],
    address: "Ingleses Norte, доставка по острову",
    telegramChannel: "https://t.me/Olga_Makey",
    website: "https://sweetfloripa.com/",
    instagram: "https://www.instagram.com/floripa_delivery?igsh=NDRyYzg3MTM3Zmpx",
    contact: "+5548991551466",
    photos: [
      "/images/floripa-delivery/floripa-delivery-1.png",
      "/images/floripa-delivery/floripa-delivery-1.jpg",
      "/images/floripa-delivery/floripa-delivery-3.jpg",
    ],
    tags: ["Еда", "Доставка"],
  },
  {
    id: 2,
    name: "Caruta",
    services: "Панамы и корсеты",
    description: "Caruta - это бренд женской одежды. Все началось с пошива одной панамы, она получилась настолько удобной и красивой, что магазин образовался сам собой. Наша особенность - натуральные ткани и индивидуальный пошив по вашим меркам",
    price: [
      { name: "Панама", price: "270 BRL" },
      { name: "Корсет от", price: "500 BRL" },
    ],
    address: "Florianópolis, доставка по острову",
    telegramChannel: "https://t.me/dr_dogova",
    website: "",
    instagram: "https://www.instagram.com/pure_sew?igsh=YzY5bWh1bTc5N201&utm_source=qr",
    contact: "",
    photos: [
      "/images/caruta/caruta-1.jpeg",
      "/images/caruta/caruta-2.jpeg",
      "/images/caruta/caruta-3.jpeg",
    ],
    tags: ["Красота", "Другое", "Одежда"],
  },
  {
    id: 3,
    name: "ИП Калиниченко Юлия Николаевна",
    services: "Доставка грузов и документов по РФ со скидкой до 60%",
    description: "Мы Транспортная компания СДЭК. Заключив с нами договор, вы получаете менеджера по сопровождению и скидки на отправки до 60%",
    price: [],
    address: "РФ",
    telegramChannel: "https://t.me/79054403334",
    website: "",
    instagram: "",
    contact: "+79054403334",
    photos: [
      "/images/yulia-kalinichenko/yulia-kalinichenko-1.png",
    ],
    tags: ["Доставка"],
  },
  {
    id: 4,
    name: "Флорипа доставка еды Ирина",
    services: "Полуфабрикаты, блины, и другая comida на заказ от повара",
    description: "Замороженные полуфабрикаты, кейтеринг, услуги повара",
    price: [
      { name: "Пельмени говядина и свинина, 950 г", price: "95 BRL" },
      { name: "Пельмени куриные, 950 г", price: "85 BRL" },
      { name: "Хинкали, 600 г", price: "60 BRL" },
      { name: "Гедза с креветками и пекинской капустой, 600 г", price: "75 BRL" },
      { name: "Вареники с картошкой и луком, 950 г", price: "60 BRL" },
      { name: "Вареники с картошкой и лесными грибами, 950 г", price: "75 BRL" },
      { name: "Котлеты куриные, 600 г", price: "40 BRL" },
      { name: "Котлеты из свинины и говядины, 600 г", price: "45 BRL" },
      { name: "Котлеты говяжьи, 600 г", price: "50 BRL" },
      { name: "Котлеты рыбные, 600 г", price: "90 BRL" },
      { name: "Фрикадельки (по мотивам IKEA), 450 г", price: "40 BRL" },
      { name: "Люля-кебаб, 600 г", price: "55 BRL" },
      { name: "Куриные отбивные, 600 г (3 шт)", price: "50 BRL" },
      { name: "Чебуреки, 6 шт", price: "40 BRL" },
    ],
    address: "Cachoeira do bom Jesus, Florianopolis, доставка по острову",
    telegramChannel: "https://t.me/povarfloripadostavka",
    website: "",
    instagram: "",
    contact: "+5541991611252",
    photos: [
      "/images/povar-irina/povar-irina-1.jpeg",
      "/images/povar-irina/povar-irina-2.jpeg",
      "/images/povar-irina/povar-irina-3.jpeg",
    ],
    tags: ["Еда"],
  },
  {
    id: 5,
    name: "Юлия Марченко",
    services: "Переводчик",
    description: "Сопровождение на прием к врачу, карторио и другие учреждения, помощь с переводом с/на португальский",
    price: [],
    address: "Florianopolis",
    telegramChannel: "https://t.me/marchenkoprava",
    website: "",
    instagram: "https://www.instagram.com/marchenko.prava?igsh=N25kMHprcjM3eTIw",
    contact: "+5548991223112",
    photos: [
      "/images/yulia-marchenko/yulia-marchenko.jpg",
    ],
    tags: ["Документы", "Переводчик"],
  },
  {
    id: 6,
    name: "Наталья Иванова",
    services: "Электроэпиляция",
    description: "Удаляю любые волосы: толстые, тонкие, черные, светлые, рыжие, седые, пушковые. На любой части тела. После курса электроэпиляции волосы гарантированно перестают расти навсегда",
    price: [
      { name: "Час", price: "350 BRL" },
    ],
    address: "Jurere",
    telegramChannel: "https://t.me/pavlova.natasha",
    website: "",
    instagram: "",
    contact: "+79639906122",
    photos: [
      "/images/natasha-pavlova/natasha-pavlova-1.jpeg",
      "/images/natasha-pavlova/natasha-pavlova-2.jpeg",
      "/images/natasha-pavlova/natasha-pavlova-3.jpeg",
    ],
    tags: ["Красота"],
  },
  {
    id: 7,
    name: "Элеанор",
    services: "Няня",
    description: "",
    price: [],
    address: "Florianópolis (ingleses)",
    telegramChannel: "https://t.me/capiva_ra",
    website: "",
    instagram: "",
    contact: "+554891523145",
    photos: [
      "/images/eleanor/photo.png",
    ],
    tags: ["Дети"],
  },
  {
    id: 8,
    name: "Blinopolis",
    services: "Блинная",
    description: "Если соскучились по настоящим русским блинам, то приходите в гости! Сладкие блины, блины с начинками и черный чай ждут вас!",
    price: [
      { name: "Блины в ассортименте от", price: "18 BRL" },
    ],
    address: "Rod. João Gualberto Soares, 56 - quiosque 1 - Ingleses do Rio Vermelho, Florianópolis - SC, 88058-300",
    telegramChannel: "",
    website: "",
    instagram: "",
    contact: "",
    photos: [
      "/images/blinopolis/blinopolis.png",
    ],
    tags: ["Еда"],
  },
  {
    id: 9,
    name: "PRO IT LTDA",
    services: "Обмен валют",
    description: "Обмен валют и криптовалют на реалы, баты, гривны и др.",
    price: [],
    address: "Florianópolis, по всему острову",
    telegramChannel: "https://t.me/obmen_money",
    website: "",
    instagram: "",
    contact: "+5548991516988",
    photos: [
      "/images/obmen-money/obmen-money.jpg",
    ],
    tags: ["IT", "Деньги", "Недвижимость"],
  },
  {
    id: 10,
    name: `Rentcar "Carro4you"`,
    services: "Аренда автомобилей, выкуп автомобилей, продажа в рассрочку",
    description: "Carro4you официальная компания. Наши принципы: - прозрачность и легальность нашей деятельности, - комфортные автомобили по доступным ценам, - отсутствие бюрократии, - гибкая система оплаты(рубли, реалы, доллары, евро, usdt). Самый низкий залог среди конкурентов. Мы регулярно обновляем свой автопарк и следим за техническим состоянием наших машин.",
    price: [
      { name: "Аренда удобных автомобилей от", price: "84 BRL" },
    ],
    address: "Florianópolis, Ingléses, Servidão José Manoel Pacífico 161",
    telegramChannel: "https://t.me/carro4you",
    website: "https://www.carro4you.com/",
    instagram: "https://www.instagram.com/carro4you_br?igsh=MTRhemp3NWN1cjU4MQ==",
    contact: "+5548996818468",
    photos: [
      "/images/car4you/car4you.png",
    ],
    tags: ["Авто"],
  },
  {
    id: 11,
    name: "Юра",
    services: "Услуги асадора, мангал-мастер",
    description: "Помогу с приготовлением шураско (мясо, рыба, птица и овощи), рассчитаю объем продуктов, помогу с закупкой и доставкой.",
    price: [
      { name: "Услуги асадора в час", price: "50 BRL" },
    ],
    address: "Florianópolis, выезд в любой район",
    telegramChannel: "https://t.me/eat_meat_floripa",
    website: "",
    instagram: "",
    contact: "+5511974362834",
    photos: [
      "/images/yury/yury.jpg",
    ],
    tags: ["Еда"],
  },
  {
    id: 12,
    name: "Irina",
    services: "Комбинированный маникюр и педикюр, работа со сложными стопами",
    description: "Мастер ногтевого сервиса (маникюр/педикюр)",
    price: [
      { name: "Маникюр", price: "100 BRL" },
      { name: "Педикюр от", price: "140 BRL" },
    ],
    address: "R. Brisamar, 191 - Ingleses Norte, Florianópolis - SC, 88058-570",
    telegramChannel: "https://t.me/irina_metso",
    website: "",
    instagram: "https://www.instagram.com/irina_metso_nails/?igsh=ZWN6eTFuZzZseThk#",
    contact: "+5548988097570",
    photos: [
      "/images/irina-metso/irina-metso-1.jpg",
      "/images/irina-metso/irina-metso-2.jpg",
      "/images/irina-metso/irina-metso-3.png",
    ],
    tags: ["Красота"],
  },
  {
    id: 13,
    name: "Time315 investimentos",
    services: "Обмен usdt, руб., на бразильский реал.",
    description: "Оплачиваем автомобили и недвижимость от вашего имени. Содействие в получении ВНЖ через инвестиции. Мы занимаемся обменом с 2020 года — надёжно, конфиденциально и с индивидуальным подходом. Имеем собственные пункты приёма наличных в десятках стран и сотнях городов по всему миру.",
    price: [
      { name: "Комиссия 2% от спот рынка usdt/brl (Binance)", price: "0 BRL" },
    ],
    address: "Флорианополис, по всему острову",
    telegramChannel: "https://t.me/Time315",
    website: "https://time315.pro/",
    instagram: "",
    contact: "+79233157315",
    photos: [
      "/images/time315/time315.jpg",
    ],
    tags: ["Деньги", "Другое"],
  },
  {
    id: 14,
    name: "Dom Brazil Real Estate Investment",
    services: "Малоэтажное строительство и девелопмент. Агентские услуги по недвижимости",
    description: "Мы — русскоговорящая строительная компания, работающая во Флорианополисе (Бразилия), специализирующаяся на малоэтажном строительстве и инвестиционных проектах. Наша команда — это профессионалы с международным опытом, которые знают, как важно сочетание качества, надёжности и прозрачности при строительстве за рубежом. Мы сопровождаем клиентов на всех этапах — от подбора участка и проектирования до строительства и сдачи объекта «под ключ». Мы строим: жилые дома и виллы; малоэтажные комплексы и таунхаусы; проекты под аренду и инвестиции. Что нас отличает: - Полное сопровождение на русском языке. - Современные технологии и качественные материалы. - Помощь в получении ВНЖ через инвестиции в недвижимость. - Работаем исключительно в одном из самых стабильных и растущих регионов Бразилии — Санта-Катарине. Мы предлагаем клиентам готовые решения и индивидуальный подход. С нами процесс строительства и инвестиций становится простым и безопасным. Оставьте Вашу заявку, и наш специалист свяжется с Вами в ближайшее время!",
    price: [],
    address: "Servidão Três Marias, 553 - Ingleses, Florianópolis - SC, 88058-648",
    telegramChannel: "https://t.me/+_rolsmvxwIs0ODMy",
    website: "https://investdombrazil.com/",
    instagram: "https://www.instagram.com/kbievskikh?igsh=ZWI2YzEzYmMxYg==",
    contact: "+5548988117424",
    photos: [
      "/images/dombrazil/dombrazil-1.png",
      "/images/dombrazil/dombrazil-2.jpg",
      "/images/dombrazil/dombrazil-3.png",
    ],
    tags: ["Бизнес", "Недвижимость"],
  },
  {
    id: 15,
    name: "Елена Трапезникова",
    services: "Логопед, очные и онлайн занятия логопедические, обучение чтению онлайн/очно",
    description: "Логопед с опытом работы 10 лет. Очный опыт с 2015г. Онлайн с 2020 года. Работа с билингвальными детьми, русский как иностранный для детей, у которых преобладает язык окружающей среды. Работа с лексикой/грамматикой/звукопроизношением и письменной речью. Работа с неговорящими детьми/детьми с задержкой речевого развития. Длительность занятия 30 минут (логопедическое) и 40 минут (обучение чтению).",
    price: [
      { name: "ОЧНОЕ логопедическое занятие разовое", price: "100 BRL" },
      { name: "ОЧНОЕ логопедическое занятие в абонементе (8 занятий/месяц), цена за занятие", price: "90 BRL" },
      { name: "ОНЛАЙН логопедическое занятие разовое", price: "80 BRL" },
      { name: "ОНЛАЙН логопедическое занятие в абонементе (8 занятий/месяц), цена за занятие", price: "70 BRL" },
    ],
    address: "R. José Onófre Pereira, 1060 - Bela Vista, Palhoça - SC, 88132-600",
    telegramChannel: "https://t.me/elena_belena",
    website: "",
    instagram: "",
    contact: "+5547936184509",
    photos: [
      "/images/elena-trapeznikova/elena-trapeznikova.jpeg",
    ],
    tags: ["Дети"],
  },
  {
    id: 16,
    name: "Anushka",
    services: "Одежда из муслина",
    description: "Муслиновая одежда 100 %хлопка: -детская, -женская, -мужская. Пеленки, детские панамки,трусики",
    price: [],
    address: "Флорианополис - доставка по острову",
    telegramChannel: "https://t.me/valova_anna",
    website: "",
    instagram: "http://instagram.com/anushka.clothing",
    contact: "+5548992084041",
    photos: [
      "/images/anushka/anushka-1.jpeg",
      "/images/anushka/anushka-2.jpeg",
      "/images/anushka/anushka-3.jpeg",
    ],
    tags: ["Одежда"],
  },
  {
    id: 17,
    name: "Айгуль",
    services: "Массажист и аниматор",
    description: "Режиссёр, сценарист, актриса, ведущая мероприятий, аниматор. Предлагаю свои услуги для детей и взрослых. Вас ждут: игры и конкурсы (активные / спокойные), квесты по мотивам любимых историй, аквагрим, мыльные пузыри, моделирование из шаров, и др. Хотите классно отметить важное событие? Собирайте друзей! Я помогу оформить пространства и идеи, проведу мероприятие. Вечер будет весёлым и душевным!",
    price: [],
    address: "Флорианополис - выезд по острову",
    telegramChannel: "https://t.me/AigulWoW",
    website: "",
    instagram: "",
    contact: "+5548992215531",
    photos: [
      "/images/aygul/aygul.jpg",
    ],
    tags: ["Дети", "Развлечения"],
  },
  {
    id: 18,
    name: "Илья Соболев",
    services: "Трансфер, handyman, строительство",
    description: "Все виды строительных работ, электрика, общестрой, покраска, мебель, дерево, бассейны",
    price: [],
    address: "Флорианополис - выезд по острову",
    telegramChannel: "",
    website: "",
    instagram: "",
    contact: "+5548991863051",
    photos: [
      "/images/ilya-sobolev/ilya-sobolev.jpg",
    ],
    tags: ["Трансфер", "Авто", "Ремонт"],
  },
  {
    id: 19,
    name: "Надежда Еремина",
    services: "Художник по росписи стен, творческие мастер-классы",
    description: "Художник по росписи стен с опытом более 15 лет. Создаю уникальные настенные произведения: от реалистичных пейзажей до абстрактных композиций. Работаю с интерьером и экстерьером. Я художник-преподаватель с 17-летним опытом. Провожу мастер-классы для детей и взрослых в различных техниках: акварель, масло, акрил, графика. С 18 лет делюсь знаниями и вдохновением, помогая раскрывать творческий потенциал каждого ученика. Индивидуальный подход, уютная атмосфера и любовь к искусству — основа моего преподавания. Свободно говорю на английском.",
    price: [],
    address: "Кампеше, Флорианополис",
    telegramChannel: "https://t.me/achegovam",
    website: "",
    instagram: "https://www.instagram.com/achegovam?igsh=dTFhOTRiMnhtNndq",
    contact: "",
    photos: [
      "/images/nadi-eremina/nadi-eremina-1.jpg",
      "/images/nadi-eremina/nadi-eremina-2.jpg",
      "/images/nadi-eremina/nadi-eremina-3.jpg",
    ],
    tags: ["Творчество", "Дети", "Ремонт"],
  },
  {
    id: 20,
    name: "Чей тортик? Машин",
    services: "Торты, десерты, хлеб, котлеты, пельмени и пр.",
    description: "Olá! Меня зовут Маша, больше трех лет я живу в чудесном Флорианополисе и готовлю для вас ❤ Что вы можете у меня заказать: - Торты, - Пельмени, котлеты и др., - Хлеб ржаной на закваске, - Капкейки, печенье и др",
    price: [
      { name: "Торт Молочная девочка", price: "от 170 BRL" },
      { name: "Торт Морковный", price: "180 BRL" },
      { name: "Торт Сникерс", price: "180 BRL" },
      { name: "Чизкейк", price: "от 170 BRL" },
      { name: "Медовик", price: "от 180 BRL" },
      { name: "Торт Роше", price: "210 BRL" },
      { name: "Меренговый торт", price: "100 BRL" },
      { name: "Капкейки, 8 шт.", price: "90 BRL" },
      { name: "Халва", price: "35 BRL" },
      { name: "Печенье в ассортименте", price: "35 BRL" },
      { name: "Профитроли", price: "45 BRL" },
      { name: "Орешки со сгущёнкой, 500 г", price: "100 BRL" },
      { name: "Хлеб ржаной на закваске", price: "от 20 BRL" },
      { name: "Сухарики ржаные с чесноком", price: "30 BRL" },
      { name: "Гранола без сахара", price: "30 BRL" },
      { name: "Пельмени с говядиной", price: "90 BRL" },
      { name: "Пельмени с курицей", price: "90 BRL" },
      { name: "Котлеты, 1 кг", price: "от 55 BRL" },
      { name: "Голубцы, 1 кг", price: "от 60 BRL" },
      { name: "Перцы фаршированные, 1 кг", price: "70 BRL" },
      { name: "Наггетсы куриные, 1 кг", price: "55 BRL" },
      { name: "Блины с начинками, 1 кг", price: "от 75 BRL" },
      { name: "Фрикадельки", price: "от 60 BRL" },
      { name: "Ёжики мясные, 1 кг", price: "60 BRL" },
      { name: "Хинкали, 1 кг", price: "60 BRL" },
      { name: "Песто", price: "60 BRL" },
      { name: "Салат Оливье, 1 кг", price: "70 BRL" },
      { name: "Крабовый салат, 1 кг", price: "70 BRL" },
      { name: "Винегрет, 1 кг", price: "60 BRL" },
    ],
    address: "Daniela, доставка по всему острову",
    telegramChannel: "https://t.me/trumul",
    website: "https://t.me/floripacake",
    instagram: "https://www.instagram.com/mariatrumul?igsh=MWhxeGhuMWE3MTRnMQ==",
    contact: "+5548992076991",
    photos: [
      "/images/trumul/trumul-1.jpg",
      "/images/trumul/trumul-2.jpg",
      "/images/trumul/trumul-3.jpg",
    ],
    tags: ["Еда", "Доставка"],
  },
  {
    id: 21,
    name: "Альбина",
    services: "Португальский язык для детей и развивающие занятия от 2 лет с выездом на дом во Флорианополисе",
    description: "Помогаю детям быстро адаптироваться к португалоязычной среде, развиваю речь, память и уверенность для успешной учебы в местной школе или садике. Развивающие занятия направлены на стимуляцию речи, воображения и критического мышления. Занятия проходят в удобное для вас время.",
    price: [],
    address: "Флорианополис",
    telegramChannel: "https://t.me/+5548988222760",
    website: "",
    instagram: "https://www.instagram.com/albinaborisova_br/",
    contact: "+5548988222760",
    photos: [
      "/images/albina/albina.jpg",
    ],
    tags: ["Образование", "Дети"],
  },
  {
    id: 22,
    name: "Дальникова Екатерина",
    services: "Обучение, воспитание, досуг детей от 3 до 10 лет",
    description: "Занятия индивидуальные и в малых группах. \"Подготовка к школе\" (обучение чтению, счету, дидактические игры), \"Детское творчество\" (рисование, лепка, аппликация), репетитор по предметам \"Русский язык\" и \"Математика\" в начальной школе. Опыт работы с детьми более 25 лет.",
    price: [
      { name: "Занятие 60 мин", price: "60 BRL" },
      { name: "Занятие 90 мин", price: "70 BRL" },
    ],
    address: "Флорианополис, Инглезес",
    telegramChannel: "https://t.me/EDalnikova",
    website: "",
    instagram: "https://www.instagram.com/detskieulybki?igsh=N3oyMTI3Ym85M2w3",
    contact: "+79183990031",
    photos: [
      "/images/ekaterina-dalnikova/dalnikova.jpg",
      "/images/ekaterina-dalnikova/dalnikova-2.jpg",
      "/images/ekaterina-dalnikova/dalnikova-3.jpg",
      "/images/ekaterina-dalnikova/dalnikova-4.jpg",
    ],
    tags: ["Образование", "Дети"],
  },
  {
    id: 23,
    name: "Даша",
    services: "Фотограф",
    description: "Фотосессия - женская, мама и малыш, беременность",
    price: [
      { name: "Фотосессия (1-2 часа)", price: "1000 BRL" },
    ],
    address: "Флорианополис, Рио Таварес",
    telegramChannel: "https://t.me/Dasharain",
    website: "https://dasharainsun.com/",
    instagram: "https://www.instagram.com/dasharain?igsh=MWNjNHBkb3UybmdlMQ==",
    contact: "+5548991988157",
    photos: [
      "/images/dasharain/dasharain-1.jpeg",
      "/images/dasharain/dasharain-2.jpeg",
      "/images/dasharain/dasharain-3.jpeg",
    ],
    tags: ["Фото/видео", "Творчество"],
  },
  {
    id: 24,
    name: "Маруся",
    services: "Детский и семейный фотограф",
    description: "Детский и семейный фотограф 🤍 Ко мне можно обратиться за такими съемками, как: -Семейные истории, -Индивидуальная, -Love Story, -Мама + ребенок, -Выездная фотосессия, -Контент, -Съемка беременности",
    price: [
      { name: "Фотосессия (40-60 мин)", price: "500 BRL" },
    ],
    address: "Флорианополис",
    telegramChannel: "https://t.me/maripetker",
    website: "https://wa.me/c/79325352211",
    instagram: "",
    contact: "+79325352211",
    photos: [
      "/images/maripetker/maripetker-1.jpg",
      "/images/maripetker/maripetker-2.jpg",
      "/images/maripetker/maripetker-3.jpg",
    ],
    tags: ["Фото/видео", "Творчество"],
  },
  {
    id: 25,
    name: "Юлия Иевская",
    services: "Арт мастер-классы, уроки ИЗО/МХК, картины на заказ",
    description: "Профессиональный художник, преподаватель ИЗО, провожу творческие мастер-классы и индивидуальные занятия рисунком, живописью акрилом, иллюстрацией, аниме и скетчингом со взрослыми и детьми в своей хоум-студии pintaria в Канасвейрасе, Флорианополис, а также набираю группу от 8 до 16 лет на уроки истории искусств(МХК). Pintaria открылась в 2022 году как проект досугового детского рисования в мини-группах на севере Флорианополиса, работает раз в неделю в выходные и на время каникул/праздников в бразильских школах. Индивидуальные занятия согласовываются по времени индивидуально. Возможен выезд по острову. Мастер-классы для взрослых объявляются в группах телеграмм и моем инстаграме. Также провожу выездные арт-мастер-классы на заказ. Продаю свои картины акрилом, а также создаю их на заказ. С 2023 года участвую в выставках в художественных галереях в нашем городе и других городах Бразилии. Viva a arte! 🎨✏️🧡",
    price: [],
    address: "Флорианополис",
    telegramChannel: "https://t.me/Yulia_Ievskaya",
    website: "https://www.instagram.com/pintaria.nortedailha?igsh=MXlnNnV5b3F6Zzdi",
    instagram: "https://www.instagram.com/yulia.ievskaya?igsh=MXhrbmM1czJpZm5oZg==",
    contact: "+5548991431175",
    photos: [
      "/images/ulia.ievskaya/ulia.ievskaya-1.jpg",
      "/images/ulia.ievskaya/ulia.ievskaya-2.jpg",
      "/images/ulia.ievskaya/ulia.ievskaya-3.jpg",
    ],
    tags: ["Творчество", "Дети", "Образование"],
  },
  {
    id: 26,
    name: "Мария Сова: Песочная терапия для взрослых и детей",
    services: "Психологические консультации, онлайн и офлайн, интегральная песочная терапия, сказкотерапия. Психологическая разгрузка, диагностика внутреннего состояния через символы, архетипы, сновидения и творческий процесс.",
    description: "Преимущества Песочной терапии: 🥰Невербальное самовыражение. Песочная терапия предоставляет возможность выражать свои чувства и мысли без необходимости подыскивать подходящие слова, что особенно ценно для тех, кто испытывает трудности с вербализацией своих эмоций. 😍 Творческий процесс. Работа с песком позволяет пациентам участвовать в творческом процессе, что стимулирует чувство созидания и поднимает самооценку. 🥰Обработка травм. Создание сцен из песка в безопасной обстановке помогает клиентам обрабатывать травматические воспоминания. 😍Разработка навыков решения проблем. Пациенты могут использовать песок и миниатюрные фигурки для моделирования реальных проблемных ситуаций, а затем искать способы решения возникающих проблем. 🥰 Улучшение самопонимания. При работе с песком пациенты часто проявляют те грани своего внутреннего мира, которых они могли бы не увидеть в традиционной вербальной терапии. 👉Песочная терапия предлагает уникальную комбинацию творческого и терапевтического процесса, которая способствует глубокому пониманию и лечению широкого спектра психологических проблем и состояний. И хотя этот метод некоторым не подходит, для многих он оказывается исключительно полезным инструментом на пути к исцелению и личностному росту. Если Вам откликается метод, кинестетик, любите песок, рекомендую попробовать песочную терапию, не пожалеете!",
    price: [
      { name: "Сессия на песке (1-1, 5 ч), взрослый", price: "250 BRL" },
      { name: "Сессия на песке (1-1, 5 ч), взрослый с ребёнком (от 5 лет)", price: "300 BRL" },
      { name: "Сессия на песке (1-1, 5 ч), ребёнок - подросток (от 7 лет)", price: "200 BRL" },
    ],
    address: "Флорианополис, район Инглезис, Sete Mares",
    telegramChannel: "https://t.me/Estrelas_Coruja",
    website: "https://vk.com/worldmapinside",
    instagram: "https://www.instagram.com/maria_corujia?igsh=YWF4Z3NtcmFyODJo",
    contact: "",
    photos: [
      "/images/maria-sova/maria-sova.jpg",
      "/images/maria-sova/maria-sova-2.jpg",
      "/images/maria-sova/maria-sova-3.jpg",
    ],
    tags: ["Творчество", "Дети", "Образование"],
  },
  {
    id: 27,
    name: "Наташа",
    services: "Фотограф",
    description: "Индивидуальные и семейные съемки",
    price: [
      { name: "Фотосессия 1-2 часа", price: "700 BRL" },
    ],
    address: "Флорианополис, Рио Таварес",
    telegramChannel: "https://t.me/ntlrmk",
    website: "",
    instagram: "https://www.instagram.com/tashashoots?igsh=cjBnM29yb2NyM2Y3",
    contact: "",
    photos: [
      "/images/tashashoots/tashashoots-1.jpeg",
      "/images/tashashoots/tashashoots-2.jpeg",
      "/images/tashashoots/tashashoots-3.jpeg",
    ],
    tags: ["Фото/видео", "Творчество"],
  },
  {
    id: 28,
    name: "IS@AK",
    services: "Все виды строительства",
    description: "Любые виды строительства и ремонта",
    price: [
      { name: "Фотосессия 1-2 часа", price: "700 BRL" }, // Похоже, это ошибка в исходных данных, так как услуга не соответствует описанию. Исправлю на основе контекста, если нужно.
    ],
    address: "Флорианополис",
    telegramChannel: "",
    website: "",
    instagram: "",
    contact: "+554197183109",
    photos: [
      "/images/isaak/isaak.jpg",
    ],
    tags: ["Ремонт"],
  },
  {
    id: 29,
    name: "Валерия Листопад",
    services: "Репетитор английского для взрослых и детей",
    description: "Английский онлайн — для тех, кто хочет говорить уверенно и с удовольствием/ Я понимаю, что в Бразилии английский не всегда на первом месте, да и в целом он тут почти бесполезен — знаю на своем опыте 👍 Но если вы часто путешествуете, работаете с международными клиентами или ваш ребёнок учится в международной школе — я здесь, чтобы помочь! Преподаю английский с 2014 года. Провожу живые, интерактивные занятия онлайн с акцентом на разговорную практику и настоящее погружение в язык по системе Cambridge. Работаю со взрослыми и мини-группами (2–4 человека: друзья, пары, коллеги). Также — по запросу — могу помочь школьникам с программой, домашкой и сложными темами. Офлайн-занятия во Флорипе — тоже по договорённости. Напишите мне, чтобы узнать подробнее о форматах, ценах и системе скидок. Мы сможем провести пробный урок — вы увидите, что онлайн-формат может быть даже более продуктивным, чем офлайн, благодаря удобным инструментам и вовлечению. Это не просто уроки, а целый опыт — интересный, эффективный и вдохновляющий.",
    price: [
      { name: "Одно индивидуальное занятие (онлайн) - от", price: "130 BRL" },
      { name: "Месяц занятий в мини-группе (онлайн) - от", price: "560 BRL" },
    ],
    address: "Barra da Lagoa, Fortaleza, онлайн",
    telegramChannel: "https://t.me/valerie_listopad",
    website: "https://listopad-eng.ru/",
    instagram: "https://www.instagram.com/listopad_eng?igsh=em9uZnhyeWNrMDg3",
    contact: "",
    photos: [
      "/images/listopad/listopad-1.jpg",
      "/images/listopad/listopad-2.jpg",
    ],
    tags: ["Образование"],
  },
  {
    id: 30,
    name: "Марина Морская",
    services: "Груминг на дому",
    description: "Груминг на дому во Флорианополисе! 🐾Вычес, 🐾Тримминг, 🐾Стрижка под машинку (без учёта породного стандарта), 🐾Подрезание когтей — всегда включено. Я грумер с 4-летним опытом. Работаю бережно, с любовью к каждому питомцу. Есть портфолио — с радостью покажу по запросу!",
    price: [],
    address: "Canasvieiras (Florianopolis) и другие районы, выезд на дом",
    telegramChannel: "https://t.me/MarinkaMorskaya",
    website: "",
    instagram: "https://www.instagram.com/petgroom_brazil?igsh=MWhndXVybXdmM3U2eA==",
    contact: "",
    photos: [
      "/images/marina-morskaya/marina-morskaya-1.jpg",
      "/images/marina-morskaya/marina-morskaya-2.jpg",
      "/images/marina-morskaya/marina-morskaya-3.jpg",
    ],
    tags: ["Питомцы"],
  },
  {
    id: 31,
    name: "Владимир",
    services: "Трансфер",
    description: "Трансфер по городу. Машина вместительная, 5 пассажиров, 5-8 чемоданов. (поездки в другие города по согласованию)",
    price: [],
    address: "Florianopolis",
    telegramChannel: "",
    website: "",
    instagram: "",
    contact: "+79952023306",
    photos: [
      "/images/vladimir/vladimir.jpg",
    ],
    tags: ["Трансфер", "Авто"],
  },
  {
    id: 32,
    name: "Asava Design",
    services: "Мебель на заказ",
    description: "Asava Design — мастерская корпусной мебели на заказ. Мы занимаемся полным циклом работ: от разработки индивидуального дизайна до производства и профессионального монтажа. Работаем с качественными материалами, уделяя внимание каждой детали. Наша мебель — это сочетание функциональности, эстетики и долговечности. Мы помогаем воплотить в жизнь любые идеи для дома, офиса или коммерческих пространств. Гарантируем точность исполнения, честные сроки и предоставляем гарантийное обслуживание. С Asava Design вы получаете не просто мебель, а решение, созданное специально для вас.",
    price: [
      { name: "Индивидуально", price: "" },
    ],
    address: "Florianopolis",
    telegramChannel: "https://t.me/Alexmoveis",
    website: "",
    instagram: "https://www.instagram.com/asava_design?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    contact: "+5548988734614",
    photos: [
      "/images/alexey-savkin/alexey-savkin-1.jpg",
      "/images/alexey-savkin/alexey-savkin-2.jpg",
      "/images/alexey-savkin/alexey-savkin-3.jpg",
    ],
    tags: ["Ремонт", "Другое"],
  },
  {
    id: 33,
    name: "Элеонора",
    services: "Остеопат, психотерапевт, физиолог",
    description: "Я остеопат и психотерапевт, физиолог, 10лет практики, 12 лет обучений, мед.образование. Краниосакральная терапия, миофасциальный релиз, биодинамическое центрирование, висцеральная остеопатия, вагинальная остеопатия - это лишь малая часть инструментов которыми я владею. Чем могу быть полезна: - Послеродовое восстановление: ставлю все внутренние органы, органы малого таза на место. - Работаю с головой, с костями черепа и крестца. - С рубцами. - С позвоночником. - С перекосами, которые мешают жить). Все манипуляции, мягкие, без грубого вмешательства и боли, остеопатические). Так же работаю с нефизическими причинами физической симптоматики)",
    price: [],
    address: "Florianopolis, выезд в любой район",
    telegramChannel: "https://t.me/eleonora_r",
    website: "",
    instagram: "",
    contact: "",
    photos: [
      "/images/eleonora/eleonora.jpg",
    ],
    tags: ["Здоровье", "Медицина"],
  },
  {
    id: 34,
    name: "Анастасия Струнина",
    services: "Индивидуальные тренировки и мини-группы",
    description: "Любой запрос 😍: 💞растяжка, 💕йога, 💞медитации, 💕стрип пластика (женские направления), 💞гимнастика для детей и взрослых, 💕 акройога для всей семьи. С августа будет доступно целение рейки 🙌 Тренер с 10 летним опытом работы с детьми и взрослыми. Педагогическое образование магистратура 👍🏼",
    price: [],
    address: "Флорианополис, Инглезес",
    telegramChannel: "https://t.me/Anastezia74",
    website: "",
    instagram: "https://www.instagram.com/anastezia74?igsh=MW5vcGV3eHRleTdkNg==",
    contact: "+79525283196",
    photos: [
      "/images/anastasia-strunina/anastasia-strunina-1.jpg",
      "/images/anastasia-strunina/anastasia-strunina-2.jpg",
    ],
    tags: ["Здоровье", "Спорт"],
  },
  {
    id: 35,
    name: "Бабулины пельмешки Floripa",
    services: "Бабулины пельмени!🥟 ручная лепка как в детстве 😋",
    description: "",
    price: [
      { name: "Пельмени с говядиной ручная лепка 1 кг", price: "85 BRL" },
      { name: "Вареники с картошкой и луком", price: "50 BRL" },
      { name: "Вареники с картошкой и грибами", price: "55 BRL" },
      { name: "Вареники с творогом", price: "50 BRL" },
      { name: "Котлеты 1 кг", price: "75 BRL" },
      { name: "Голубцы", price: "85 BRL" },
      { name: "Манты", price: "85 BRL" },
    ],
    address: "Флорианополис, доставка по острову",
    telegramChannel: "https://t.me/gizatullinarina",
    website: "https://t.me/pelmenifloripa",
    instagram: "",
    contact: "",
    photos: [
      "/images/babuliny-pelmeni/babuliny-pelmeni-1.jpg",
      "/images/babuliny-pelmeni/babuliny-pelmeni-2.jpg",
      "/images/babuliny-pelmeni/babuliny-pelmeni-3.jpg",
    ],
    tags: ["Еда"],
  },
  {
    id: 36,
    name: "Домашняя еда с любовью",
    services: "🥘 Домашняя еда с любовью — теперь во Флорианополисе!",
    description: "В меню: • Борщ, щи, харчо, • Котлеты, тефтели, голубцы, гуляш, • Курица в сливках, • Пюре, гречка, рис, макароны. ✨ Отдельно: меню для малышей 1–3 лет —пюре из овощей и фруктов. На пару 💨 порции по 250г. Только полезные продукты. • Брокколи с красным яблоком • Цветная капуста с тыквой • Морковь с зеленым яблоков ✨ Доступные цены — от 20 до 30 реалов за порцию. ✨ Доставка по острову",
    price: [
      { name: "Порция", price: "20-30 BRL" },
    ],
    address: "Флорианополис, доставка по острову",
    telegramChannel: "https://t.me/StruninDmitriy",
    website: "",
    instagram: "",
    contact: "+5548991313354",
    photos: [
      "/images/dom-eda/dom-eda-1.jpg",
    ],
    tags: ["Еда"],
  },
  {
    id: 37,
    name: "Татьяна Хрулева",
    services: "Репетитор, учитель начальных классов",
    description: "Мне 64 года. Я учитель начальных классов. Работаю по старой советской программе. Большой опыт работы. В том числе математика 5-7 класс.",
    price: [],
    address: "Флорианополис, Инглезес",
    telegramChannel: "",
    website: "",
    instagram: "",
    contact: "+5548988627758",
    photos: [
      "/images/tatiana-hruleva/tatiana-hruleva.jpg",
    ],
    tags: ["Образование", "Дети"],
  },
  {
    id: 38,
    name: "Иван Иванов",
    services: "Заточка ножей",
    description: "Произвожу быстро и качественно заточку ножей на дому, работаю во всём городе Флорианополис.",
    price: [
      { name: "Заточка всех ножей", price: "30 BRL" },
    ],
    address: "Флорианополис",
    telegramChannel: "https://t.me/Ivan_az_esm",
    website: "",
    instagram: "",
    contact: "+5548998453084",
    photos: [
      "/images/ivan-ivanov/ivan-ivanov-1.jpg",
      "/images/ivan-ivanov/ivan-ivanov-2.jpg",
      "/images/ivan-ivanov/ivan-ivanov-3.jpg",
    ],
    tags: ["Ремонт", "Другое"],
  },
  {
    id: 39,
    name: "Виталий Простотин",
    services: "Тренер по пляжному теннису",
    description: "Меня зовут Виталий, я тренер по пляжному теннису. Провожу тренировки в Кампеше. Если вы хотите попробовать или серьезно тренироваться, приходите, буду рад вам!",
    price: [],
    address: "Флорианополис, Кампеше",
    telegramChannel: "https://t.me/vitpros",
    website: "",
    instagram: "",
    contact: "+5548991973929",
    photos: [
      "/images/vitaly-prostotin/vitaly-prostotin-1.jpg",
      "/images/vitaly-prostotin/vitaly-prostotin-2.jpg",
      "/images/vitaly-prostotin/vitaly-prostotin-3.jpg",
    ],
    tags: ["Спорт", "Здоровье"],
  },
  {
    id: 40,
    name: "Карина",
    services: "Мастер маникюра и педикюра",
    description: "✨ Меня зовут Карина, я мастер маникюра и педикюра с 5 летним опытом работы. Работаю в современных техниках (комби маникюр, тонкое укрепление гелем, Smart педикюр, наращивания..), использую качественное оборудование и материалы, каждый инструмент — как новый: стерильно, безопасно, профессионально. 💅 Моя уютная студия находится в центре города. 🅿️ Удобная парковка для клиентов. ☕️ Чай, кофе и приятная атмосфера — всегда в комплекте! С радостью создам для вас идеальный маникюр.",
    price: [],
    address: "Florianopolis, Centro, Av Rio Branco 817",
    telegramChannel: "",
    website: "",
    instagram: "https://www.instagram.com/its_my_beauty_lab?igsh=MW03a2xsM3cyZGJtZg==",
    contact: "+5548998351099",
    photos: [
      "/images/karina/karina-1.jpg",
      "/images/karina/karina-2.jpg",
      "/images/karina/karina-3.jpg",
    ],
    tags: ["Красота"],
  },
  {
    id: 41,
    name: "Даша Простотина",
    services: "Аюрведический йога массаж, массаж для беременных, массажное свидание для пар",
    description: "С большой любовью предлагаю вам сеансы Аюрведического Йога массажа — для беременных и для пар. Этот метод, созданный мастером Кусум Модак, объединяет 🧘‍♀️йогу и 🌿аюрведу, включает более 120 маневров и направлен на глубокую физическую и эмоциональную трансформацию. Массаж проходит на полу на массажном коврике с использованием кунжутного масла и порошка из лекарственного растения Каламус (семейство имбирных). 👋🦶Сначала я разогреваю тело руками и ступнями ног надавливающими, стимулирующими кровоток движениями, затем делаю растяжку и скручивания. 🪬Такая интенсивная проработка тела в сочетании с 🗣️осознанным дыханием даёт состояние медитации и восстановления жизненной энергии — Праны. 🤍Вы почувствуете глубокую проработку мышц, 🩵улучшение кровотока, 💛лимфодренаж, 🩷снятие напряжения, 💜уменьшение блоков и зажимов в теле, ❤️практику диафрагмального дыхания, 💚улучшение подвижности суставов, 💙расслабление на физическом и психо-эмоциональном уровне. Сессия для беременных — это не только массаж. Мы беседуем о важности диафрагмального дыхания, картируем мышцы вдоха и выдоха, обсуждаем дыхание в родах и создаём пространство для отдыха и расслабления тела. Всё проходит 🏡у вас дома — с ковриком, пледом, подушками и атмосферой заботы. А для пар я создала особый формат — 💑«массажное свидание»: 4 часа, в которые я делюсь знаниями, ставлю руки, обучаю разогреву тела и растяжкам. Это возможность вырваться на свидание и стать ближе друг к другу. Как минимум — вы получите массаж от меня и время вдвоём без суеты. Как максимум — освоите ещё один язык любви, который останется с вами на долгие годы 🙏 С меня — романтическая атмосфера, всё необходимое для массажа, практика, чай 🍵, арома ✨, фотосопровождение 📸 и приятный подарок 🎁 С вас — 4 часа свободного времени и желание пойти в новый опыт 🔥",
    price: [
      { name: "Массаж для беременных · у вас дома · 2–2,5 ч", price: "300 BRL" },
      { name: "Массажное свидание для пары · в студии Cyta Yoga · 4 ч, район Santa Mônica", price: "650 BRL" },
      { name: "Индивидуальный массаж · у меня дома · 1ч30мин", price: "220 BRL" },
      { name: "Курс из 4х массажей · у меня дома", price: "800 BRL" },
      { name: "Индивидуальный массаж · у вас дома (Кампеше ±) · 1ч30мин", price: "260 BRL" },
      { name: "Курс из 4х массажей · у вас дома (Кампеше ±)", price: "960 BRL" },
      { name: "Индивидуальный массаж · у вас дома (другие районы)", price: "300 BRL" },
      { name: "Курс из 4х массажей · у вас дома (другие районы)", price: "1100 BRL" },
      { name: "Индивидуальный массаж · в студии Cyta Yoga, район Santa Mônica", price: "320 BRL" },
      { name: "Курс из 4х массажей · в студии Cyta Yoga, район Santa Mônica", price: "1200 BRL" },
    ],
    address: "Florianopolis, Morro das Pedras или Santa Mônica. Возможен выезд на дом",
    telegramChannel: "https://t.me/ProstotinaDasha",
    website: "https://www.instagram.com/prostofamilylife",
    instagram: "https://www.instagram.com/dasha_prostotina/#",
    contact: "+5548991981673",
    photos: [
      "/images/dasha-prostotina/dasha-prostotina-1.jpg",
      "/images/dasha-prostotina/dasha-prostotina-2.jpg",
      "/images/dasha-prostotina/dasha-prostotina-3.jpg",
    ],
    tags: ["Красота", "Здоровье"],
  },
  {
    id: 42,
    name: "Анастасия",
    services: "Гимнастика для детей, йога для беременных, танцы для мам с новорожденными",
    description: "Открыт набор в группы: 1. группа по гимнастике для детей от 3 лет! 💕 И мальчики, и девочки велком 🙌 2. Йога для беременных и не только 😉 3. Танцы мам с новорожденными. Уроки 2 или 3 раза в неделю по 45/55 минут, оплата 100 реал за класс с чел, время согласуем при наборе от 2 человек в группу 👌 Всего 5 мест в каждую группу!",
    price: [
      { name: "Урок (45/55 мин)", price: "100 BRL" },
    ],
    address: "Флорианополис, Инглезес, Villa Palmeras 2",
    telegramChannel: "https://t.me/Anastezia74",
    website: "",
    instagram: "https://www.instagram.com/anastezia74?igsh=MW5vcGV3eHRleTdkNg==",
    contact: "+79525283196",
    photos: [
      "/images/anastasia-strunina-2/anastasia-strunina-1.jpg",
      "/images/anastasia-strunina-2/anastasia-strunina-2.jpg",
      "/images/anastasia-strunina-2/anastasia-strunina-3.jpg",
    ],
    tags: ["Здоровье", "Спорт"],
  },
  {
    id: 43,
    name: "THEYA Events Company",
    services: "Команда, которая воплощает в жизнь любые, даже самые смелые идеи 💡",
    description: "Мы организуем: 🎉 корпоративы и частные вечеринки. 🎂 дни рождения и свадьбы. 🎀 gender party и девичники. 🌿 авторские путешествия, ретриты и туры. 📍 Сейчас мы во Флорианополисе (Бразилия). 🌍 Но у нас за плечами десятки успешных мероприятий в России, Таиланде и других странах. 💻 Продолжаем работать с этими регионами удалённо и развиваемся в Бразилии. ❤️ Работаем с душой — мы сами артисты, ивенты для нас — это искусство. 👥 Лично сопровождаем каждое мероприятие — от идеи до последнего гостя. 🧩 Всё подбираем индивидуально — с вниманием, гибкостью и любовью к деталям. Если вы ищете команду, которой можно доверить важное — пишите нам 📩 THEYA создаст магию, которую вы запомните навсегда ✨",
    price: [],
    address: "Флорианополис",
    telegramChannel: "https://t.me/Anastezia74",
    website: "",
    instagram: "https://www.instagram.com/anastezia74?igsh=OHJqZXllbDlncjdz",
    contact: "+79525283196",
    photos: [
      "/images/theya/theya-1.jpg",
      "/images/theya/theya-2.jpg",
      "/images/theya/theya-3.jpg",
    ],
    tags: ["Развлечения"],
  },
  {
    id: 44,
    name: "Виктория Брик",
    services: "Парикмахер-стилист по волосам",
    description: "Меня зовут Вика, и я – парикмахер-стилист по волосам. Люблю делать волосы красивыми и здоровыми! Работаю с окрашиванием, особенно люблю блонд, делаю стрижки, ламинирование, корректирую и окрашиваю брови, а также занимаюсь восстановлением волос. Хочу порадовать вас приятным бонусом в течении этой недели: при окрашивании с прядями дарю услугу лечения волос в подарок! Буду рада помочь вам преобразиться и подчеркнуть вашу естественную красоту. Пишите в личку – обсудим ваши желания и подберём идеальный образ! ✨",
    price: [],
    address: "Флорианополис",
    telegramChannel: "https://t.me/VictoriaIvanova88",
    website: "",
    instagram: "https://www.instagram.com/_viktoria_brik?igsh=Y2MzcGJqdWtxMHh3&utm_source=qr",
    contact: "",
    photos: [
      "/images/victoria-brik/victoria-brik-1.jpg",
      "/images/victoria-brik/victoria-brik-2.jpg",
      "/images/victoria-brik/victoria-brik-3.jpg",
    ],
    tags: ["Красота"],
  },
  {
    id: 45,
    name: "Клининг Casa Magica",
    services: "Клининг",
    description: "Наши услуги: ✅ Уборка апартаментов, домов и офисов. ✅ Разовые и генеральные уборки. ✅ Абонементы на регулярные уборки (1 раз в неделю). 🛏 Подготовка жилья к заселению и уборка после выселения. 🤝 Сотрудничаем с профессионалами по: — Чистке мебели, — Мойке витринных стекол (офисы, дома). У партнёров есть разрешение на работы на высоте!",
    price: [
      { name: "💰 Стоимость рассчитывается индивидуально — учитываем площадь, количество санузлов, наличие балкона, а также перечень необходимых работ.", price: "" },
    ],
    address: "Флорианополис",
    telegramChannel: "https://t.me/Casa_magica",
    website: "",
    instagram: "https://www.instagram.com/casamagica_floripa?igsh=and6MDNuOXd6ajVk",
    contact: "",
    photos: [
      "/images/casa-magica/casa-magica.jpeg",
    ],
    tags: ["Уборка"],
  },
  {
    id: 46,
    name: "The Rossa Group Imobiliária",
    services: "Покупка и продажа недвижимости, аренда и выгодные инвестиции, от застройщиков и вторичный рынок",
    description: "Мы — международная группа компаний, специализирующаяся на работе с недвижимостью, строительстве и привлечении инвестиций по всему миру. Уже 6 лет успешно работаем на бразильском рынке, предлагая свои услуги, оказывая поддержку нашим клиентам, помогая им приобретать прибыльную недвижимость для различных нужд. Услуги компании: - Подбор и покупка недвижимости под индивидуальный запрос, включая премиум-сегмент, по специальным условиям. - Сопровождаем клиента при получении ВНЖ и гражданства Бразилии. - Организация тура по объектам недвижимости «под ключ». - Управление объектом после покупки: аренда, обслуживание, перепродажа. - Комплексная юридическая поддержка в индивидуальных ситуациях.",
    price: [],
    address: "R. dos Polvos, 61 - 01 - Jurerê, Florianópolis - SC, 88053-565",
    telegramChannel: "",
    website: "https://rossagroupbrazil.com",
    instagram: "https://www.instagram.com/grouptherossa.rus/profilecard/?igsh=MTM4YzE5dGVodmJoZA==",
    contact: "+5547992116579",
    photos: [
      "/images/rossa-group/rossa-group-2.jpeg",
      "/images/rossa-group/rossa-group-1.jpeg",
    ],
    tags: ["Недвижимость", "Документы", "Другое"],
  },
  {
    id: 47,
    name: "Samovar Books",
    services: "Детские книги на русском языке в Бразилии",
    description: "Соскучились по чтению на русском языке? Устали просить знакомых и близких, чтобы привезли книги? В нашем интернет-магазине есть книги на любой вкус: от историй, знакомых нам с детства, до современных популярных изданий. Также мы можем привезти книги под заказ. Переходите на наш сайт, чтобы выбрать ту книгу, которая подойдет именно вашему малышу. Все книги на сайте в наличии, поэтому вы их получите в течение нескольких дней после оформления заказа, отправляем каждый заказ в соответствии с тарифами Correios",
    price: [
      { name: "Доставка по всей территории Бразилии бесплатна при заказе от", price: "249 BRL" },
    ],
    address: "Доставка по всей Бразилии",
    telegramChannel: "https://t.me/samovarbooks",
    website: "https://samovarbooks.com.br/",
    instagram: "https://www.instagram.com/samovarbooks?utm_source=qr",
    contact: "",
    photos: [
      "/images/samovar-books/samovar-books-1.jpg",
      "/images/samovar-books/samovar-books-2.jpg",
      "/images/samovar-books/samovar-books-3.jpg",
    ],
    tags: ["Дети", "Развлечения", "Образование"],
  },
  {
    id: 48,
    name: "Анастасия Азарова",
    services: "Сексолог, психолог, секс-коуч, танцетерапевт",
    description: "Я Настя, танцующий сексолог на нашем острове магии!) Дипломированный сексолог, психолог, секс-коуч, танцетерапевт, занимаюсь женским здоровьем через восстановление МТД более 5 лет. Провожу волшебные девичники 18+ а так же заражаю любовью к танцам! Занятия по направлениям femme dance и latina mix проходят в районах Trindade в школе «Dance Ímpar» и в районе Jurerê в школе «Maria Morena». Актуальное расписание можно узнать, написав лично.",
    price: [],
    address: "Trindade в школе Dance Ímpar и Jurerê в школе Maria Morena",
    telegramChannel: "https://t.me/nastyasxg",
    website: "https://nastyasxg.tilda.ws",
    instagram: "https://www.instagram.com/nastyasxg/#",
    contact: "",
    photos: [
      "/images/nastya/nastya.jpg",
      "/images/nastya/nastya-2.jpg",
      "/images/nastya/nastya-3.jpg",
    ],
    tags: ["Развлечения", "Образование", "Здоровье"],
  },
  {
    id: 49,
    name: "Юлия Коста",
    services: "Курсы португальского языка",
    description: "Курсы португальского языка онлайн. ✅Группа максимум 4 человека ✅Занятия в Зуме 2 раза в неделю по 60 минут ✅Все материалы предоставляются ✅Русскоязычный преподаватель ✅Стоимость 7000 рублей за 8 занятий ✅2 занятия в каждом месяце можно пропустить с возможностью продления. Coco и cocô, metro и metrô, bicho e bicha, и еще много милых нюансов португальского языка ждут тебя на наших уроках! Bora estudar! 🤓",
    price: [
      { name: "8 занятий", price: "7000 RUB" }, 
    ],
    address: "Москва, занятия онлайн",
    telegramChannel: "https://t.me/lunchevaj",
    website: "",
    instagram: "",
    contact: "",
    photos: [
      "/images/yulia-costa/yulia-costa.jpg",
    ],
    tags: ["Образование"],
  },
  {
    id: 50,
    name: "Павел",
    services: "Международный трансфер, перевозка домашних животных по ЛатАм",
    description: "⚡️⚡️Автомобильная перевозка домашних любимцев по Парагваю 🇵🇾, Бразилии 🇧🇷, Аргентине 🇦🇷, Уругваю 🇺🇾 и другим странам Латинской Америки. ⚡️⚡️ Индивидуальный трансфер вашего питомца лично и в сопровождении хозяина⚡️⚡️ ➡️ адресная быстрая доставка ➡️ помощь в оформлении документов ➡️ официальный ввоз ➡️ оплата после доставки ➡️ фото/видео отчёты",
    price: [],
    address: "Парагвай",
    telegramChannel: "https://t.me/Caroy52",
    website: "https://t.me/paraguaiv",
    instagram: "",
    contact: "+595994855743",
    photos: [
      "/images/pavel-caroy/pavel-caroy.jpg",
    ],
    tags: ["Трансфер", "Питомцы"],
  },
  {
    id: 51,
    name: "Irina Nazarova",
    services: "Роды мечты во Флорианополисе, помощь с документами",
    description: "-роды в Бразилии, - дородовое сопровождение беременной, -доула-переводчик на родах, -сопровождение/перевод на консультациях, - помощь с документами",
    price: [
      { name: "Доула на родах", price: "700 USD" },
      { name: "Переводчик на консультациях (в час)", price: "150 BRL" }, 
      { name: "Оформление ВНЖ", price: "500 USD" },
    ],
    address: "Флорианополис",
    telegramChannel: "https://t.me/Irina_befit",
    website: "",
    instagram: "https://www.instagram.com/irina_tvoyadoulainfloripa/?igsh=MndjNGNzcGM2b2Ez&utm_source=qr#",
    contact: "+5548988274286",
    photos: [
      "/images/irina-nazarova/irina-nazarova.JPG",
    ],
    tags: ["Роды", "Переводчик", "Документы"],
  },
  {
    id: 52,
    name: `Татьяна Гайсина`,
    services: "Услуги переводчика онлайн, разные направления",
    description: "Я предоставляю профессиональные услуги по письменному и устному переводу онлайн (русский - португальский - русский). Перевод не жураментадо.Работаю с юридическими, деловыми и повседневными текстами. Также занимаюсь вопросами недвижимости исключительно в Балнеариу Камбориу (SC, Бразилия) консультации, сопровождение сделок, помощь при аренде и покупке объектов.",
      price: [
           { name: "Обычные темы (бытовые, сопровождение, общение), в час", price: "150 BRL" },
           { name: "Бизнес, юридические, технические темы, в час", price: "300 BRL" },
           { name: "За срочность, в час", price: "250 BRL" },
           { name: "Крупные корпорации, в час", price: "500 BRL" },
    ],
    address: "Балнеарио-Камбориу, Флорианополис и т.д",
    telegramChannel: "https://t.me/Tatti_Tatti2",
    website: "",
    instagram: "",
    contact: "+5547988864165",
    photos: [
      "/images/tatiana-gaisina/tatiana-gaisina-1.jpg",
      "/images/tatiana-gaisina/tatiana-gaisina-2.jpg",
    ],
      tags: ["Переводчик", "Недвижимость"],
  },
    {
    id: 53,
    name: `Kiss my cake`,
    services: "Торты советской классики, муссовые, бенто, с декором!",
    description: "Муссовые торты, Торты советской классики (Наполеон, медовик, киевский и др.), Бисквитные торты с декором на праздники, Бенто торты, И другие десерты!",
      price: [
           { name: "Медовик", price: "110 BRL" },
           { name: "Наполеон", price: "110 BRL" },
           { name: "Сметанник", price: "110 BRL" },
          { name: "Прага", price: "125 BRL" },
          { name: "Киевский", price: "165 BRL" },
          { name: "Бенто", price: "100 BRL" },
    ],
    address: "Centro, Florianópolis, доставка по острову",
    telegramChannel: "https://t.me/kissmycake",
    website: "",
    instagram: "https://www.instagram.com/kissmycake.floripa/?igsh=YW02bmZoYjJueWx2&utm_source=qr#",
    contact: "+5548991699194",
    photos: [
      "/images/kissmycake/kissmycake.jpg",
    ],
      tags: ["Доставка", "Еда", "Развлечения"],
  },
    {
    id: 54,
    name: `Анна Де Андраде`,
    services: "Английский язык",
    description: "Преподаю Английский очно и онлайн. Большой опыт работы с детьми.",
      price: [
           { name: "Индивидуально", price: "100 BRL" },
           { name: "В группе", price: "50 BRL" },
    ],
    address: "Ingleses, Florianópolis",
    telegramChannel: "https://t.me/annananana353",
    website: "",
    instagram: "",
    contact: "",
    photos: [
      "/images/anna-de-andrade/anna-de-andrade.jpg",
    ],
      tags: ["Дети", "Образование"],
  },
      {
    id: 55,
    name: `Наталья Tashhhka`,
    services: "Семейный фотограф",
    description: "Фотография - это прежде всего воспоминание о вас. Поэтому вместе с вами мы создаем эти воспоминания неповторимыми. Я снимаю: семейные истории, Беременность, Пары, Индивидуальные портреты, роды.",
      price: [
           { name: "Семейная или индивидуальная съемка от", price: "800 BRL" },
           { name: "Роды", price: "1400 BRL" },
    ],
    address: "Florianópolis",
    telegramChannel: "https://t.me/tashhhka",
    website: "https://tashhhka.com/",
    instagram: "https://www.instagram.com/tashhhka_ph/",
    contact: "",
    photos: [
      "/images/tashhhka/tashhhka-1.jpg",
      "/images/tashhhka/tashhhka-2.jpg",
      "/images/tashhhka/tashhhka-3.jpg",
    ],
     tags: ["Фото/видео", "Творчество"],
  },
      {
    id: 56,
    name: `Татьяна Микула`,
    services: "Семейный фотограф",
    description: "Меня зовут Татьяна, я семейный фотограф. Снимаю прогулки: лёгкие, тёплые, живые. Моя задача — передать настоящие эмоции. Чтобы фотографии были не просто красивыми, а пробирали до мурашек и пронесли через года историю вашей семьи",
      price: [
           { name: "Все исходники + 100 фото в цветокоррекции, 1,5 часа", price: "550 BRL" },
           { name: "Бюджетное предложение, 1 час (фото без обработки)", price: "300 BRL" },
    ],
    address: "Campeche, Florianópolis",
    telegramChannel: "https://t.me/tatianamikula",
    website: "",
    instagram: "https://www.instagram.com/floripa__family_stories/?igsh=MTQ2MHE2NHI2NmJrcw%3D%3D&utm_source=qr#",
    contact: "",
    photos: [
      "/images/tatiana-mikula/tatiana-mikula-1.jpg",
      "/images/tatiana-mikula/tatiana-mikula-2.jpg",
      "/images/tatiana-mikula/tatiana-mikula-3.jpg",
    ],
     tags: ["Фото/видео", "Творчество"],
  },
        {
    id: 57,
    name: `Юрий`,
    services: "Фото/ видео съемка с дрона",
    description: "Съемка с дрона (фото/видео, объекты недвижимости, съемка мероприятий, спортивных событий, серфинга), монтаж видео",
      price: [
           { name: "Стоимость зависит от проекта", price: "" },
    ],
    address: "Florianópolis",
    telegramChannel: "https://t.me/yuriy2694",
    website: "",
    instagram: "https://www.instagram.com/modric_94?igsh=MWdyOWY2bTE2Z20xdg==",
    contact: "+5548991520211",
    photos: [
      "/images/yury-dron/yury-dron-1.jpg",
      "/images/yury-dron/yury-dron-2.jpg",
      "/images/yury-dron/yury-dron-3.jpg",
    ],
     tags: ["Фото/видео", "Творчество"],
  },
          {
    id: 58,
    name: `Екатерина Полякова`,
    services: "Переводчик с/на португальский, передержка животных",
    description: "1. Переводчик с/на португальский и сопровождающий в медицинские организации, полицию, карторио. 2. Услуги по передержке домашних животных. Частный дом в районе Рио Вермельо, без других животных. О себе: Ветеринарный врач, 10 лет стажа. Большой опыт содержания собак, кошек и экзотических животных. Врач лабораторной диагностики. Хорошие отзывы в наличии:)",
      price: [
    ],
    address: "Florianópolis, Rio Vermelho",
    telegramChannel: "https://t.me/katepolyakovabr",
    website: "",
    instagram: "",
    contact: "",
    photos: [
      "/images/katia-polyakova/katia-polyakova.jpg",
    ],
     tags: ["Питомцы", "Переводчик", "Документы"],
  },
  {
    id: 59,
    name: `Михаил Савченко`,
    services: "Эксперт в области искусственного интеллекта, автоматизации бизнес-процессов и Web3-технологий",
    description: "Основатель Inite Solutions — команды разработчиков, создающей интеллектуальные системы на базе no-code и low-code решений. 🚀 Направления деятельности Помогаю компаниям внедрять AI-решения и автоматизировать рутинные процессы с помощью современного технологического стека: AI & Автоматизация: - GPT-ассистенты и чат-боты, - N8N-автоматизация рабочих процессов, - Интеграции с популярными платформами (Telegram, WhatsApp, CRM-системы), - Разработка умных воронок продаж, Обучение и консультации: - Индивидуальное обучение AI — персональные программы для предпринимателей и специалистов, - Командное обучение AI — корпоративные тренинги по внедрению ИИ в бизнес-процессы, - Консультации по цифровой трансформации, - Менторинг по использованию AI-инструментов в работе. ⚡️ Принципы работы: - Быстрая реализация — фокус на MVP и итеративном развитии, - Без лишней теории — только проверенные на практике решения, - Результат превыше процесса — минимум документооборота, максимум действий, - Прозрачность — понятные сроки, бюджеты и метрики успеха. 🎯 Целевая аудитория. Кому помогаю: - Предпринимателям и стартапам на этапе масштабирования, - Компаниям с растущими операционными процессами, - Экспертам и инфлюенсерам для автоматизации клиентского сервиса, - Бизнесам, готовым внедрять AI-технологии. 🌍 География и контакты: Базируюсь между Флорианóполисом (Бразилия) и Пхукетом (Таиланд). Работаю с клиентами по всему миру в удаленном формате.",
      price: [
    ],
    address: "Florianópolis / по всему миру в удаленном формате",
    telegramChannel: "https://t.me/mikefluff",
    website: "",
    instagram: "",
    contact: "",
    photos: [
     "/images/eleanor/photo.png",
    ],
     tags: ["Бизнес", "IT", "Документы"],
  },
    {
    id: 60,
    name: `Дарья Ермолаев`,
    services: "Фотограф",
    description: "Дарья Ермолаев — фотограф, работающий на стыке документалистики, искусства и интуиции. Родилась в России, живёт и работает в Бразилии. Основательница cosmic mom fotografia. Известна как «богиня света и теней», она создаёт глубокие визуальные рассказы о рождении, семье и красоте настоящего момента. Её работы находят отклик у тех, кто ищет не постановку, а магию будней.",
      price: [
    ],
    address: "Florianópolis",
    telegramChannel: "https://t.me/CosmicMomFotografia",
    website: "https://cosmicfoto.com/",
    instagram: "www.instagram.com/cosmicmomfotografia",
    contact: "",
    photos: [
     "/images/cosmicfoto/cosmicfoto-1.jpg",
     "/images/cosmicfoto/cosmicfoto-2.jpg",
     "/images/cosmicfoto/cosmicfoto-3.jpg",
    ],
     tags: ["Фото/видео", "Творчество", "Роды"],
  },
      {
    id: 61,
    name: `Maryana`,
    services: "Домашняя выпечка",
    description: "Домашняя выпечка. Скоро появятся Юмбрики - эклеры с творожным кремом.",
   price: [
  { name: "Торт «Графские развалины» (2 кг)", price: "145 BRL" },
  { name: "— + по желанию: изюм и орешки", price: "+5 BRL" },
  { name: "Шарлотка (1 кг 250 г)", price: "65 BRL" },
  { name: "Кексы (12 штук)", price: "65 BRL" },
  { name: "Рогалики с яблоками и корицей (порция ~35 шт, ~800 г)", price: "75 BRL" },
  { name: "Рогалики с шоколадом (порция ~35 шт, ~800 г)", price: "75 BRL" },
],
    address: "Florianópolis, Canasvieiras",
    telegramChannel: "https://t.me/Maryanabrasil",
    website: "https://t.me/sobremesasbrasil",
    instagram: "",
    contact: "",
    photos: [
     "/images/maryana/maryana-1.jpg",
    ],
     tags: ["Еда"],
  },
        {
    id: 62,
    name: `Relax.Massage.Annie`,
    services: "Тайский массаж и тайская кухня",
    description: "Меня зовут Анни, я специалист по тайскому массажу и тайской кухне (иногда ☺️). Тайский массаж сочетает в себе древние техники и современные терапевтические методы. Я предлагаю: • Облегчение хронической боли и мышечного напряжения, • Восстановление после спортивных травм и растяжений мышц, • Увеличение гибкости, стимуляция кровообращения и улучшение общего самочувствия, • Традиционный тайский массаж на полу или на массажном столе, • Расслабляющий массаж с маслом, • Массаж ног, • Массаж шеи, плеч и спины, • Массаж с горячими камнями, • Пренатальный массаж, • Постнатальный массаж  ",
   price: [
  { name: "Длительность каждого сеанса составляет 60 минут", price: "от 200 BRL" },
],
    address: "Rodovia Armando Calil Bulos, 5188, Ingleses, Florianópolis",
    telegramChannel: "",
    website: "",
    instagram: "https://www.instagram.com/relax.massage.annie?igsh=dGxrNzEzNmRqaW8y&utm_source=qr",
    contact: "+554884336316",
    photos: [
     "/images/thai/thai-1.jpg",
      "/images/thai/thai-2.jpg",
      "/images/thai/thai-3.jpg",
    ],
     tags: ["Красота", "Здоровье"],
  },
          {
    id: 63,
    name: `Clean Home Floripa`,
    services: "Профессиональная чистка мягкой мебели и озонирование помещений",
    description: "🧼 Профессиональная чистка мягкой мебели и озонирование помещений во Флорианополисе. Когда в последний раз вы чистили матрас или диван? 🤔 В обивке накапливаются пыль, бактерии, аллергены, частицы кожи и даже плесень. Это влияет не только на запах, но и на ваше здоровье и качество сна. 🛋️ Мы профессионально чистим диваны, матрасы, кресла и изголовья. 🌿 Озонируем помещения для удаления запахов, бактерий и спор плесени. ✔️ Используем безопасные, гипоаллергенные средства — подходит для детей и беременных. 📍Работаем во Флорианополисе и окрестностях. 📩 Пишите в директ или в Instagram 📷 Фото «до и после» — в профиле!",
   price: [
],
    address: "Florianópolis и окрестности",
    telegramChannel: "https://t.me/tatianakbr",
    website: "",
    instagram: "https://instagram.com/cleanhomefloripa?igshid=MzRlODBiNWFlZA==",
    contact: "",
    photos: [
     "/images/clean-home/clean-home.jpg",
    ],
     tags: ["Уборка", "Здоровье"],
  },
  {
    id: 64,
    name: `Алексей`,
    services: "Графический дизайн",
    description: "Меня зовут Алексей, я профессиональный графический дизайнер с более чем 15-летним опытом работы с крупными корпорациями и стартапами. Среди моих клиентов — PepsiCo, Mercedes-Benz, Danone и многие другие известные бренды. 🖌️ Моя специализация: — Разработка логотипов и фирменного стиля с нуля, — Создание упаковки, этикеток и бренд-дизайна для FMCG, — Дизайн полиграфии: каталоги, презентации, буклеты, — Разработка рекламных макетов для офлайн и диджитал, — Подготовка дизайн-гайдов и брендбуков, — Редизайн существующих брендов и упаковки, — Креативные концепции для социальных сетей и digital, — Дизайн POSM, мерча, сувенирной продукции. Работаю с задачами любого уровня сложности — от старта малого бизнеса до масштабных сетевых брендов. Помогаю упаковать идею так, чтобы она выглядела ярко, профессионально и конкурентно. ✅ Работаю строго в срок, всегда на связи. ✅ Знаю, как «говорить» с печатниками и производителями упаковки. ✅ Делаю дизайн, который реально продаёт, и привлекает клиентов, а не просто красиво выглядит. 📩 По вопросам и предложениям пишите в личку. Буду рад новым интересным проектам и долгосрочному сотрудничеству! 🚀",
   price: [
],
    address: "Florianópolis, онлайн",
    telegramChannel: "https://t.me/Dangerstaff",
    website: "https://www.behance.net/mia_visual/projects",
    instagram: "",
    contact: "",
    photos: [
     "/images/mia/mia-1.jpg",
     "/images/mia/mia-2.jpg",
     "/images/mia/mia-3.jpg",
    ],
     tags: ["IT", "Другое", "Бизнес"],
  },
    {
    id: 65,
    name: `MIA Design`,
    services: "Дизайн интерьеров",
    description: "Мы — студия дизайна интерьеров и архитектуры MIA Design, работаем по всему миру и делаем проекты жилых и общественных пространств — от апартаментов и вилл до ресторанов и отелей — в разных странах. 🔹 Чем мы занимаемся: — Проектируем жилые пространства: апартаменты, виллы, загородные дома и клубные резиденции, — Разрабатываем коммерческие и общественные интерьеры: кафе, рестораны, офисы, отели, коворкинги, коммерческие площади, — Создаём функциональные планировочные решения и полный комплект рабочих чертежей, — Делаем фотореалистичные 3D-визуализации, чтобы увидеть интерьер ещё до начала работ, — Предоставляем авторский надзор и сопровождение проекта на всех этапах — от концепции до реализации, — Консультируем по выбору материалов, мебели и декора. 🏠 Хоумстейджинг: Отдельное направление нашей работы — профессиональная подготовка объектов недвижимости к продаже или аренде. Хоумстейджинг помогает выделить ваш объект на рынке, увеличить его стоимость и привлечь больше заинтересованных покупателей или арендаторов ",
   price: [
],
    address: "Florianópolis, онлайн",
    telegramChannel: "https://t.me/Maria_Uanna",
    website: "https://miadesign.su/",
    instagram: "",
    contact: "",
    photos: [
     "/images/miadesign/miadesign-1.jpg",
     "/images/miadesign/miadesign-2.jpg",
     "/images/miadesign/miadesign-3.jpg",
    ],
     tags: ["Недвижимость", "Бизнес"],
  },
      {
    id: 66,
    name: `Виталия`,
    services: "Косметолог",
    description: "Я — Виталия, сертифицированный косметолог и специалист по естественному омоложению лица. В моей практике — более 15 техник массажа, популярных в Европе, Азии и России. Среди них: – французский скульптурный, – миофасциальный, – блефаролифтинг, – ремодулирующий, – шейно-воротниковой зоны (ШВЗ), – бирманский массаж головы  Я не работаю по шаблону. На первом приёме провожу диагностику:оцениваю состояние кожи, мышц,  осанки. На её основе подбираю индивидуальное сочетание техник и процедур — чтобы достичь желаемого результата за минимальный срок. В моём арсенале также: – чистки лица, – микронидлинг, – уходовые программы для коррекции эстетических задач, – и др. Каждая техника и процедура решает свою задачу. В комплексе они дают выраженный, стойкий эффект за меньшее количество сеансов. Работаю по предварительной записи: 📍 Сан-Паулу (возле терминала Тиете), 📍 Флорианополис — выезд раз в 1–2 месяца",
price: [
  { name: "Чистка лица — Атравматичная", price: "350 BRL" },
  { name: "Чистка лица — Механическая", price: "180 BRL" },
  { name: "Чистка лица — Комбинированная", price: "350 BRL" },
  { name: "Чистка лица — УЗ пилинг", price: "180 BRL" },

  { name: "Пилинг — Энзимный", price: "150 BRL" },
  { name: "Пилинг — Rose de Mer (Christina)", price: "350 BRL" },
  { name: "Пилинг — Фруктовый", price: "180 BRL" },
  { name: "Пилинг — Карбокситерапия", price: "280 BRL" },

  { name: "Маска — Альгинатная", price: "180 BRL" },
  { name: "Маска — Бандажная", price: "150 BRL" },
  { name: "Маска — Коллагеновая", price: "120 BRL" },
  { name: "Маска — По типу и состоянию кожи", price: "80 BRL" },

  { name: "Массаж лица, шеи и декольте — Миофасциальный", price: "350 BRL" },
  { name: "Массаж лица, шеи и декольте — Ремоделирующий", price: "300 BRL" },
  { name: "Массаж лица, шеи и декольте — Французский скульптурный", price: "300 BRL" },
  { name: "Массаж лица, шеи и декольте — Блефаролифтинг (китайская техника)", price: "300 BRL" },
  { name: "Массаж — Бирманский релакс головы", price: "300 BRL" },
  { name: "Массаж — Гуаша", price: "250 BRL" },
  { name: "Массаж — Шейно-воротниковая зона (ШВЗ)", price: "300 BRL" },
  { name: "Массаж — Крио шариками красоты", price: "150 BRL" },

  { name: "✨ Авторская программа омоложения", price: "550 BRL" },
  { name: "— Уход Christina, массаж, маска", price: "вкл." },

  { name: "Аппаратные процедуры — Микронидлинг Cellular Renewal", price: "350 BRL" },
  { name: "Аппаратные процедуры — Алмазный пилинг", price: "250 BRL" },
  { name: "Аппаратные процедуры — Хронотерапия LED mask", price: "100 BRL" },
  { name: "Аппаратные процедуры — Броссаж", price: "150 BRL" },
  { name: "Аппаратные процедуры — Фонофорез + пептидный комплекс", price: "150 BRL" },
  { name: "Аппаратные процедуры — Дарсонваль (1 зона) моно", price: "150 BRL" },
  { name: "Аппаратные процедуры — Дарсонваль (1 зона) в комплексе", price: "50 BRL" },

  { name: "Программа ухода Christina — Rose de Mer", price: "350 BRL" },
  { name: "Программа ухода Christina — Bio Phyto", price: "300 BRL" },
  { name: "Программа ухода Christina — Illustrious", price: "300 BRL" },

  { name: "Брови — Коррекция", price: "100 BRL" },
  { name: "Брови — Окрашивание хной", price: "150 BRL" },
  { name: "Брови — Окрашивание краской", price: "120 BRL" },

  { name: "Ресницы — Окрашивание хной", price: "150 BRL" },
  { name: "Ресницы — Окрашивание краской", price: "120 BRL" },

  { name: "Депиляция — Руки полностью (бандажная техника)", price: "280 BRL" },
  { name: "Депиляция — Ноги полностью (бандажная техника)", price: "350 BRL" },
  { name: "Депиляция — Бикини (классика)", price: "250 BRL" },
  { name: "Депиляция — Глубокое бикини", price: "350 BRL" },
  { name: "Депиляция — Подмышки", price: "150 BRL" },
  { name: "Депиляция — Лицо (1 зона)", price: "80 BRL" }
],
    address: "Флорианополис — выезд раз в 1–2 месяца",
    telegramChannel: "https://t.me/vitalia_cosmetologa",
    website: "https://t.me/cosmetologia_vit",
    instagram: "https://www.instagram.com/vitalia_cosmetologa?igsh=anB3MWxkMHcyMnRq",
    contact: "",
    photos: [
     "/images/vitalia/vitalia-1.jpg",
     "/images/vitalia/vitalia-2.jpg",
    ],
     tags: ["Красота", "Здоровье"],
  },
      {
    id: 67,
    name: `Unhas Cinco Estrelas`,
    services: "Маникюр и педикюр, гель-лак",
    description: "Наши мастера прошли обучение по российской методике GoManic и знают, как создать идеальный маникюр именно для вас.",
   price: [
],
    address: "Armando Calil Bulos 5795, Ingleses, Florianópolis - SC",
    telegramChannel: "",
    website: "",
    instagram: "https://www.instagram.com/unhas_cinco_estrelas?igsh=YXFiN2psamRvd2Fq",
    contact: "+5548991970099",
    photos: [
     "/images/unhas/unhas-1.jpg",
     "/images/unhas/unhas-2.jpg",
     "/images/unhas/unhas-3.jpeg",
    ],
     tags: ["Красота", "Здоровье"],
  },
        {
    id: 68,
    name: `Иван Rem_monte`,
    services: "Ремонт и обслуживание ноутбуков, ПК, игровых приставое, техники Apple",
    description: "Меня зовут Иван, я оказываю услуги по ремонту, обслуживанию ноутбуков, Macbook и другой техники Apple, игровых приставок.🔥 Бесплатная диагностика и консультация, 🔥Ремонт и обслуживание компьютеров и ноутбуков (системные проблемы, не включается, синий экран, физическое повреждение, ремонт после залития, чистка от пыли, замена термопасты, обслуживание и ремонт видеокарты и т.д.); 🔥 Апгрейд вашего ПК или ноутбука.",
   price: [
],
    address: "Trindade-Florianópolis, выезд по острову",
    telegramChannel: "https://t.me/rem_monte",
    website: "https://t.me/rem_monte",
    instagram: "",
    contact: "+5511983972772",
    photos: [
     "/images/remmonte/remmonte.jpg",
    ],
     tags: ["IT", "Ремонт"],
  },
          {
    id: 69,
    name: `BrazilFamily`,
    services: "Сопровождение родов в Бразилии",
    description: "Наше сопровождение родов в Бразилии — это спокойная и комфортная атмосфера рядом с океаном и заботой о вас и малыше. 🤱 Сопровождение родов с профессиональной доулой 👉ВНЖ/гражданство/CPF/аренда",
   price: [
],
    address: "Florianópolis, выезд по острову",
    telegramChannel: "https://t.me/MarchenkoPrava",
    website: "https://brazil-family.com/",
    instagram: "https://www.instagram.com/brazil_family_floripa/",
    contact: "+5548991223112",
    photos: [
     "/images/brazil-family/brazil-family.jpg",
    ],
     tags: ["Роды", "Недвижимость", "Документы"],
  },
            {
    id: 70,
    name: `Денис Бурлаков`,
    services: "Покупка и аренда недвижимости, переводчик",
    description: "Обучение и сертификаты: 4 сертификата по португальскому языку, включая Celpe Bras. Стажировка и обучение в старейшем агентстве недвижимости Флорианополиса Brognoli. Услуги: Покупка и аренда недвижимости во Флорианополисе. Сопровождение и представление в государственных органах на португальском языке. Решение вопросов на португальском языке. Оформление документов, CPF, свидетельства о рождении , ВНЖ, загранпаспорта и других.",
   price: [
],
    address: "Florianópolis, выезд по острову",
    telegramChannel: "https://t.me/denbur",
    website: "https://www.facebook.com/denis.burlakov.9",
    instagram: "https://www.instagram.com/denis_burlakov/",
    contact: "+5548988241630",
    photos: [
     "/images/denis-burlakov/denis-burlakov-1.jpg",
     "/images/denis-burlakov/denis-burlakov-2.jpg",
     "/images/denis-burlakov/denis-burlakov-3.jpg",
    ],
     tags: ["Переводчик", "Недвижимость", "Документы"],
  },
              {
    id: 71,
    name: `Wheelzy`,
    services: "Подбор, покупка и аренда авто",
    description: "Прокат (аренда) авто, мин 7 дн. Подбор(покупка) авто. Продажа своих авто. Выкуп вашего авто. Предпродажная подготовка авто. Полировка дефектов царапин. Полировка фар. Мелкий, локальный подкрас авто. Химчистка салона.",
   price: [
],
    address: "Florianópolis, выезд по острову",
    telegramChannel: "https://t.me/azhenya123",
    website: "https://wheelzy.glide.page",
    instagram: "",
    contact: "+79827771473",
    photos: [
     "/images/wheelzy/wheelzy.jpg",
    ],
     tags: ["Авто"],
  },
                {
    id: 72,
    name: `Татьяна`,
    services: "Доула, переводчик, оформление документов",
    description: "🦋🐬🐳Меня зовут Татьяна, я живу во Флорианополисе уже четыре года и помогаю по разным вопросам нашим соотечественникам. Являюсь медработником и сертифицированной доулой, сопровождаю беременных к врачам и на родах. Являюсь переводчиком, преподаю русский и португальский язык иностранцам уже более 10 лет. Делаю переводы  документов и любой сложности литературы! Помогаю в оформлении ВНЖ и гражданства Бразилии, и т.д. Сопровожу вас в любую инстанцию, где необходим профессиональный подход к переводу и решения поставленных задач. ",
   price: [
],
    address: "Florianópolis, выезд по острову",
    telegramChannel: "https://t.me/Mikhailovna25",
    website: "https://wheelzy.glide.page",
    instagram: "",
    contact: "+557799671077",
    photos: [
     "/images/tatyana/tatyana.jpg",
    ],
     tags: ["Медицина", "Роды", "Переводчик", "Документы"],
  },
];

export default specialists;
